import React, { Suspense, lazy } from "react";
const FooterBar = lazy(() => import("../components/FooterBar.jsx"));
const Header = lazy(() => import("../components/Header.jsx"));
// const CookiesNotification = lazy(() => import("../components/cookies/CookiesNotification")); // ❌ REMOVIDO - Não há mais cookies
const HelpdeskStart = lazy(() => import("../components/helpdesk/HelpdeskStart.jsx"));
const SpeedNotification = lazy(() => import("../components/SpeedNotification.jsx"));
// Consentimento obrigatório de Termo de Uso e Política de Privacidade (GET/COB 94).
// Inerte para visitantes anônimos; bloqueia a tela do usuário logado com pendência.
const GateAceiteTermos = lazy(() => import("../components/legal/GateAceiteTermos.jsx"));
// const BannerPortals = lazy(() => import("../components/BannerPortals"));

export default function Layout(props) {
  // let currentPath = window.location.pathname;

  return (
    <div id="wrap" className="d-flex flex-column">
      {/* ❌ COOKIE NOTIFICATION REMOVIDA - Site agora é livre de cookies */}
      <Suspense fallback={<div>Carregando (052)...</div>}>
        <HelpdeskStart />
      </Suspense>
      <Suspense fallback={null}>
        <GateAceiteTermos />
      </Suspense>
      <div id="header" className="d-flex flex-column">
        <header>
          <Suspense fallback={<div>Carregando (053)...</div>}>
            <Header subdomain={props.subdomain} />
          </Suspense>
        </header>
        {/* {currentPath !== "/" && !currentPath.includes("/sie") && (
          <div className="d-flex w-100 col-12 sticky-top">
            <Suspense fallback={<div></div>}>
              <BannerPortals showFixed={true} />
            </Suspense>
          </div>
        )} */}
      </div>
      {/* A altura minima é igual a altura do viewport - altura do header - altura do footer */}
      <div
        id="main"
        className="d-flex"
        style={{ minHeight: "calc(100vh - 300px)" }}
        // style={currentPath !== "/" && !currentPath.includes("/sie") ? { marginTop: "120px", minHeight: "calc(100vh - 56px - 300px)" } : { marginTop: "56px", minHeight: "calc(100vh - 56px - 300px)" }}
      >
        <div className="d-flex w-100 flex-column">
          <Suspense fallback={<></>}>
            <SpeedNotification />
          </Suspense>
          {props.children}
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      <div id="footer" className="d-flex w-100" style={{ width: '100vw', maxWidth: '100vw' }}>
        <footer className="w-100">
          <Suspense fallback={<div>Carregando (055)...</div>}>
            <FooterBar subdomain={props.subdomain} />
          </Suspense>
        </footer>
      </div>
    </div>
  );
}
